import { createContext, useContext, useState, useCallback } from "react";
import { translations, LANGS } from "@/i18n/translations";

const STORAGE_KEY = "pnmf_lang";
const LanguageContext = createContext(null);

function detectLang() {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved && translations[saved]) return saved;
  const codes = LANGS.map((l) => l.code);
  const nav = (navigator.languages || [navigator.language || "en"]).map((l) => l.toLowerCase());
  for (const l of nav) {
    const base = l.split("-")[0];
    if (base === "ht" || l.includes("creole") || l.includes("kreyol")) return "ht";
    if (codes.includes(base)) return base;
  }
  return "en";
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(detectLang);

  const setLang = useCallback((code) => {
    if (!translations[code]) return;
    localStorage.setItem(STORAGE_KEY, code);
    document.documentElement.lang = code;
    setLangState(code);
  }, []);

  const value = { lang, setLang, d: translations[lang] || translations.en, langs: LANGS };
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
